<script lang="ts">
    import PolicyText from 'src/components/main/policy/components/privacy-policy/PrivacyPolicy.svelte'
    import VisitCommunity from 'src/components/main/#common/visit-community/VisitCommunity.svelte'
    import MainLayout from "../#common/layout/Layout.svelte"
</script>

<svelte:head>
    <title>Privacy Policy</title>
    <meta name="description" content="We are delighted that you have shown interest in our Website, located at, (the «Website»), which is Realis (the «Company»). Data protection is of a particularly high priority for us. The use of our Website is possible without any indication of personal data; however, if you want to use services via our Website, processing of personal data could become necessary."/>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <PolicyText/>
<!--        <VisitCommunity/>-->
    </svelte:fragment>
</MainLayout>

